<template>
<div class="sell-area" :style="{'width': clientWidth + 'px', 'height': clientHeight + 'px'}">
    <div class="top">
        <div class="status"><span class="squar color-skyblue"></span>销量</div>
        <!-- <div class="status"><span class="squar color-orange"></span>已发送</div> -->
        <!-- <div class="status"><span class="line line-bg-blue"></span>订单完成率</div> -->
        <div class="status"><span class="line line-bg-orange"></span>完成率</div>
    </div>
    <div class="content clearfix">
        <div class="left">
            <div id="histogram1"></div>
            <div id="histogram2"></div>
            <div id="histogram3"></div>
            <div id="histogram4"></div>
        </div>
        <div class="center">
            <div class="center-map">
                <div class="text">
                    <!-- <div class="text-item">地区总完成率<span class="text-item-value">{{mapData.system_company*100}}%</span></div>
                    <div class="text-item">西电平台与系统内企业<span class="text-item-value">{{mapData.west_platform*100}}%</span></div> -->
                </div>
                <div class="map">
                    <div class=" datong"><div id="datong"></div><span class="value">{{parseInt(mapData.datong*100)}}%</span></div>
                    <!-- <div class=" yulin"><span class="value">{{}}</span></div> -->
                    <div class=" yanan"><div id="yanan"></div><span class="value">{{parseInt(mapData.system_company*100)}}%</span></div>
                    <div class=" xizhou"><div id="xizhou"></div><span class="value">{{parseInt(mapData.taiyuan*100)}}%</span></div>
                    <div class=" changzhi"><div id="changzhi"></div><span class="value">{{parseInt(mapData.jinzhong*100)}}%</span></div>
                    <div class=" yuncheng"><div id="yuncheng"></div><span class="value">{{parseInt(mapData.weinan*100)}}%</span></div>
                    <div class=" shangluo"><div id="shangluo"></div><span class="value">{{parseInt(mapData.west_platform*100)}}%</span></div>
                    <!-- <div class=" ankang"><span class="value">40%</span></div> -->
                    <div class=" baoji"><div id="baoji"></div><span class="value">{{parseInt(mapData.xianyang*100)}}%</span></div>
                    <div class=" yanan-data"><div id="yanan-data"></div><span class="value">{{parseInt(mapData.yanan*100)}}%</span></div>
                    <div class=" xian-data"><div id="xian-data"></div><span class="value">{{parseInt(mapData.xian*100)}}%</span></div>
                    <div class="system-company"></div>
                    <div class="xidian-state"></div>
                </div>
            </div>
        </div>
        <div class="right">
            <div id="histogram6"></div>
            <div id="histogram7"></div>
            <div id="histogram8"></div>
            <div id="histogram5"></div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            clientWidth: '',
            clientHeight: '',
            option: {
                title: {
                    text: '' ,
                    x: 'center',
                    y: 'top'
                },
                color: ['#00A4E1', '#FE5500', '#3E2EA2'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '0',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        interval: 0,
                        // rotate: 40
                    },
                    data: ['兰州厂', '北京厂', '无锡厂', '大连', '北京厂', '无锡厂', '大连']
                    // data: []
                }],
                yAxis: [{
                    type: 'value',
                    splitLine: {
                        show: false
                    },

                    name: '/吨'
                },
                {
                    type: 'value',
                    scale: true,
                    name: '完成率：%',
                    min: 0,
                    max: 200,
                    // boundaryGap: [0.2, 0.2]
                }],
                series: [{
                        name: '销量',
                        type: 'bar',
                        barGap: 0,
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                        data: [320, 332, 301, 334],
                        // data: []
                    },
                    {
                        name:'完成率',
                        yAxisIndex: 1,
                        lineStyle: {
                            color: '#00A4E1'
                        },
                        type:'line',
                        data: [90, 80, 70, 60]
                    },
                    
                ]
            },
            option1: {
                // color: ['#FE5500','#00A4E1'],
                color: ['#fff','#00A4E1', ],
                series: [
                    {
                        type:'pie',
                        radius: ['50%', '70%'],
                        hoverAnimation: false,
                        avoidLabelOverlap: false,
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data:[
                            {value:335, name:''},
                            {value:310, name:''}
                        ]
                    }
                ]
            },
            mapData: {}
        }
    },
    created() {
        this.$nextTick(() => {
            this.clientWidth = document.documentElement.clientWidth;
            this.clientHeight = document.documentElement.clientHeight;
            this.axios.get('https://xarh.sprucesmart.com/api/v2/weekly')
            .then(res => {
                res.data.pl_data.forEach((item, index) => {
                    var tempOption = JSON.parse(JSON.stringify(this.option));
                    tempOption.title.text = item.pl_name + '销量及完成率';
                    tempOption.series[1].data = this.change100Times(item.pl_completion_rate) 
                    tempOption.series[0].data = item.pl_sales_volume
                    tempOption.xAxis[0].data = item.area_list
                    var myChart = this.$echarts.init(document.getElementById('histogram' + (index + 1)));
                    myChart.setOption(tempOption);
                });
                this.mapData = res.data.middle_map_week_data[0];
                this.initMap()
            })
        })
        
    },
    methods: {
        change100Times(params) {
            for(let i = 0, len = params.length; i < len; i++) {
                params[i] *= 100;
                params[i] = parseFloat(params[i]).toFixed(1);
            }
            return params;
        },
        initMap() {
            let datongChart = this.$echarts.init(document.getElementById('datong'));
            var datongNoComplete = parseInt(100 - this.mapData.datong * 100);
            var datongComplete = parseInt(this.mapData.datong * 100);
            var datongOption = JSON.parse(JSON.stringify(this.option1))
            if(datongNoComplete <= 0) {
                datongOption.series[0].data[1].value = 100;
                datongOption.series[0].data[0].value = 0;
            }
            else {
                datongOption.series[0].data[1].value = datongComplete;
                datongOption.series[0].data[0].value = datongNoComplete;
            }
            let datongTempOption = datongOption;
            datongChart.setOption(datongTempOption)

            let yananChart = this.$echarts.init(document.getElementById('yanan'));
            var yananNoComplete = parseInt(100 - this.mapData.system_company * 100);
            var yananComplete = parseInt(this.mapData.system_company * 100);
            var yananOption = JSON.parse(JSON.stringify(this.option1));
            console.log(yananComplete);
            if(yananNoComplete <= 0) {
                console.log('yananNoComplete')
                yananOption.series[0].data[1].value = 100;
                yananOption.series[0].data[0].value = 0;
            }
            else {
                console.log('yananComplete')
                yananOption.series[0].data[1].value = yananComplete;
                yananOption.series[0].data[0].value = yananNoComplete;
            }
            let yananTempOption = yananOption;
            yananChart.setOption(yananTempOption)

            let xizhouChart = this.$echarts.init(document.getElementById('xizhou'));
            var xizhouNoComplete = parseInt(100 - this.mapData.taiyuan * 100);
            var xizhouComplete = parseInt(this.mapData.taiyuan * 100);
            var xizhouOption = JSON.parse(JSON.stringify(this.option1));
            if(xizhouNoComplete <= 0) {
                xizhouOption.series[0].data[1].value = 100;
                xizhouOption.series[0].data[0].value = 0;
            }
            else {
                xizhouOption.series[0].data[1].value = xizhouComplete;
                xizhouOption.series[0].data[0].value = xizhouNoComplete;
            }
            console.log(xizhouOption)
            console.log(xizhouChart)
            let xizhouTempOption = xizhouOption;
            xizhouChart.setOption(xizhouTempOption)

            let changzhiChart = this.$echarts.init(document.getElementById('changzhi'));
            var xizhouNoComplete = parseInt(100 - this.mapData.jinzhong * 100);
            var xizhouComplete = parseInt(this.mapData.jinzhong * 100);
            if(xizhouNoComplete <= 0) {
                this.option1.series[0].data[1].value = 100;
                this.option1.series[0].data[0].value = 0;
            }
            else {
                this.option1.series[0].data[1].value = xizhouComplete;
                this.option1.series[0].data[0].value = xizhouNoComplete;
            }
            let changzhiTempOption = this.option1;
            changzhiChart.setOption(changzhiTempOption)

            let yunchengChart = this.$echarts.init(document.getElementById('yuncheng'));
            var xizhouNoComplete = parseInt(100 - this.mapData.weinan * 100);
            var xizhouComplete = parseInt(this.mapData.weinan * 100);
            if(xizhouNoComplete <= 0) {
                this.option1.series[0].data[1].value = 100;
                this.option1.series[0].data[0].value = 0;
            }
            else {
                this.option1.series[0].data[1].value = xizhouComplete;
                this.option1.series[0].data[0].value = xizhouNoComplete;
            }
            let yunchengTempOption = this.option1;
            yunchengChart.setOption(yunchengTempOption)

            let shangluoChart = this.$echarts.init(document.getElementById('shangluo'));
            var shangluoNoComplete = parseInt(100 - this.mapData.west_platform * 100);
            var shangluoComplete = parseInt(this.mapData.west_platform * 100);
            if(shangluoNoComplete <= 0) {
                this.option1.series[0].data[1].value = 100;
                this.option1.series[0].data[0].value = 0;
            }
            else {
                this.option1.series[0].data[1].value = shangluoComplete;
                this.option1.series[0].data[0].value = shangluoNoComplete;
            }
            let shangluoTempOption = this.option1;
            shangluoChart.setOption(shangluoTempOption)

            let baojiChart = this.$echarts.init(document.getElementById('baoji'));
            var baojiNoComplete = parseInt(100 - this.mapData.xianyang * 100);
            var baojiComplete = parseInt(this.mapData.xianyang * 100);
            if(baojiNoComplete <= 0) {
                this.option1.series[0].data[1].value = 100;
                this.option1.series[0].data[0].value = 0;
            }
            else {
                this.option1.series[0].data[1].value = baojiComplete;
                this.option1.series[0].data[0].value = baojiNoComplete;
            }
            let baojiTempOption = this.option1;
            baojiChart.setOption(baojiTempOption)

            let yananDataChart = this.$echarts.init(document.getElementById('yanan-data'));
            var yananDataNoComplete = parseInt(100 - this.mapData.yanan * 100);
            var yananDataComplete = parseInt(this.mapData.yanan * 100);
            if(yananDataNoComplete <= 0) {
                this.option1.series[0].data[1].value = 100;
                this.option1.series[0].data[0].value = 0;
            }
            else {
                this.option1.series[0].data[1].value = yananDataComplete;
                this.option1.series[0].data[0].value = yananDataNoComplete;
            }
            let yananDataTempOption = this.option1;
            yananDataChart.setOption(yananDataTempOption)

            let xianDataChart = this.$echarts.init(document.getElementById('xian-data'));
            var xianDataNoComplete = parseInt(100 - this.mapData.xian * 100);
            var xianDataComplete = parseInt(this.mapData.xian * 100);
            if(yananDataNoComplete <= 0) {
                this.option1.series[0].data[1].value = 100;
                this.option1.series[0].data[0].value = 0;
            }
            else {
                this.option1.series[0].data[1].value = xianDataComplete;
                this.option1.series[0].data[0].value = xianDataNoComplete;
            }
            let xianDataTempOption = this.option1;
            xianDataChart.setOption(xianDataTempOption)
        }
    }
}
</script>

<style scoped>
.sell-area {
    position: relative;
    background-color: #FCFCFC;
    padding-top: 70px;
}

.content {
    width: 1300px;
    margin: 0 auto;
}

.top {
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translate(-50%, 0);
    margin: 0 auto;
}
.status {
    display: inline-block;
    margin-right: 20px;
    height: 18px;
    line-height: 18px;
}
.squar {
    display: inline-block;
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
    margin-right: 8px;
}
.line {
    display: inline-block;
    width: 37px;
    height: 5px;
    position: relative;
    top: -2px;
    margin-right: 8px;
}
.line-bg-blue {
    background-image: url(../../../assets/imgs/dingdanlu.png);
    background-size: 100% 100%;
}
.line-bg-orange {
    background-image: url(../../../assets/imgs/wanhcneglv.png);
    background-size: 100% 100%;
}
.color-skyblue {
    background-color: #00A4E1;
}
.color-orange {
    background-color: #FE5500;
}
.color-blue {
    background-color: #3E2EA2;
}

.left,
.center,
.right {
    float: left;
}
.left {
    width: 420px; 
    margin-right: 20px;
}
.center {
    margin-right: 20px;
    width: 400px;
    padding-top: 100px;
}
.left > div,
.right > div,
.center > div#histogram5 {
    width: 400px;
    height: 250px;
    padding: 10px;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 13px #ccc;
    margin-bottom: 20px;
}
.text {
    padding-top: 55px;
    margin-left: 50px;
    /* margin-bottom: 70px; */
}
.text-item {
    position: relative;
    line-height: 30px;
    width: 100%;
    padding-left: 35px;
    background-image: url(../../../assets/imgs/diqu2.png);
    background-repeat: no-repeat;
    background-position: 0 center;
    margin-bottom: 20px;
}
.text-item-value {
    position: absolute;
    font-size: 12px;
    left: 4px;
    top: 50%;
    transform: translate(0, -50%);
}
.map {
    position: relative;
    width: 317px;
    height: 478px;
    margin-left: 10px;
    background-image: url(../../../assets/imgs/xiaoditu2.png);   
    background-size: 100% 100%;
}
.system-company {
    position: absolute;
        left: -18px;
    top: 125px;
    width: 115px;
    height: 28px;
    padding-left: 32p;
    font-size: 16px;
    color: #000000;
    background-image: url(../../../assets/imgs/xitongnei2.png);
    background-repeat: no-repeat;
}
.xidian-state {
    position: absolute;
        right: -114px;
    top: 354px;
    width: 98px;
    height: 23px;
    padding-left: 32px;
    font-size: 16px;
    color: #000000;
    background-image: url(../../../assets/imgs/pingtai2.png);
    background-repeat: no-repeat;
}
.datong,
.yulin,
.yanan,
.xizhou,
.changzhi,
.yuncheng,
.shangluo,
.ankang,
.baoji,
.xian-data,
.yanan-data {
    position: absolute;
    right: 29px;
    top: -35px;
    width: 37px;
    height: 68px;
    background-image: url(../../../assets/imgs/bg-datong1.png);
    background-size: 100% 100%;
}
.datong > .value,
.yulin > .value,
.yanan > .value,
.xizhou > .value,
.changzhi > .value,
.yuncheng > .value,
.shangluo > .value,
.ankang > .value,
.baoji > .value,
.yanan-data > .value,
.xian-data > .value
 {
    position: absolute;
    left: 5px; 
    top: 10px;
    font-size: 12px;
}
.yanan-data {
    right: 150px;
    top: 44px;
    width: 37px;
    height: 88px;
    background-image: url(../../../assets/imgs/yanan-data.png);
    background-size: 100% 100%;
}

.xian-data {
        top: 397px;
    width: 96px;
    height: 36px;
    background-image: url(../../../assets/imgs/xian-data.png);
    background-size: 100% 100%;
}
.xian-data > .value {
    left: 65px;
}
.xian-data > .value {
    left: 65px;
}
.baoji > .value {
    left: 8px;
}
.yulin {
    right: 150px;
    top: 44px;
    /* width: 37px; */
    /* height: 88px; */
    /* background-image: url(../../../assets/imgs/bg-yulin.png); */
    /* background-size: 100% 100%; */
}
.yanan {
    right: 237px;
    top: 156px;
    width: 112px;
    height: 73px;
    background-image: url(../../../assets/imgs/bg-yanan1.png);
    background-size: 100% 100%;
}
.xizhou {
    right: -39px;
    top: 71px;
    width: 121px;
    height: 60px;
    background-image: url(../../../assets/imgs/bg-xizhou.png);
    background-size: 100% 100%;
}
.xizhou > .value {
    left: 90px;
}
.changzhi {
    right: -39px;
    top: 178px;
    width: 79px;
    height: 60px;
    background-image: url(../../../assets/imgs/bg-changzhi.png);
    background-size: 100% 100%;
}
.changzhi > .value {
    left: 49px;
}
.yuncheng {
    right: -5px;
    top: 279px;
    width: 112px;
    height: 36px;
    background-image: url(../../../assets/imgs/bg-yuncheng.png);
    background-size: 100% 100%;
}
.yuncheng > .value {
    left: 81px;
}
.shangluo {
    right: 23px;
    top: 349px;
    width: 112px;
    height: 36px;
    background-image: url(../../../assets/imgs/bg-shangluo1.png);
    background-size: 100% 100%;
}
.shangluo > .value {
    left: 84px;
}
.baoji {
    right: 242px;
    top: 262px;
    width: 37px;
    height: 88px;
    background-image: url(../../../assets/imgs/bg-yulin.png);
    background-size: 100% 100%;
}
.ankang {
    right: 72px;
    top: 413px;
    width: 112px;
    height: 36px;
    background-image: url(../../../assets/imgs/bg-yuncheng.png);
    background-size: 100% 100%;
}
.ankang > .value {
    left: 81px;
}

#datong,
#yulin,
#yanan,
#xizhou,
#changzhi,
#yuncheng,
#shangluo,
#ankang,
#baoji,
#xian-data,
#yanan-data
 {
    position: absolute;
    width: 52px;
    height: 92px;
    left: -8px;
    top: -27px;
}
#yanan {
    left: -9px;
    top: -27px;
}
#xizhou {
    left: 77px;
}
#changzhi {
    left: 35px;
}
#yuncheng {
    left: 68px;
}
#shangluo {
    left: 71px;
}
#xian-data {
    left: 52px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataBoard/bigDataBoard/SellAreaWeek.vue